import { Outlet } from 'react-router-dom';
import { Footer } from './Footer';
import { Header } from './Header';
import { MobileActions } from './MobileActions';

export function Layout() {
  return (
    <div className="site-app">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <Header />
      <main id="main-content"><Outlet /></main>
      <Footer />
      <MobileActions />
    </div>
  );
}
